import React from 'react'
import { inject, observer } from 'mobx-react'

import { Label } from 'sdc-i18n-react'

import { DateFormatter } from './datetime/date'

@inject('store')
@observer
export class DetailsDateView extends React.Component {
  render() {
    return <tr style={{color: '#999'}}>
      <td><Label value={this.props.label} /></td>
      <td><DateFormatter date={this.props.store.selected[this.props.field]} fmt={this.props.fmt || "DD.MM.YYYY"} /></td>
    </tr>
  }
}
